const API_BASE_URL = "https://pt-api.digit-a.net/api"
/**
 * Obtiene la tasa de compra desde la API de ESG.
 * @param {object} params - Parámetros para personalizar la petición.
 * @returns {Promise<object>} - La respuesta de la API.
 */
export const getBuyRate = async (params = {}) => {
     // Creamos la cadena de consulta para nuestro backend
     const queryString = new URLSearchParams(params).toString();

     const url = `${API_BASE_URL}/esg/buy-rate?${queryString}`;

     try {
          const response = await fetch(url);

          if (!response.ok) {
               const errorData = await response.json();
               throw new Error(errorData.message || `Error en el servidor: ${response.status}`);
          }

          const data = await response.json();
          return data;

     } catch (error) {
          console.error("Error al obtener la tasa de compra:", error);
          throw error;
     }
};

/**
 * Inicia una orden de compra y obtiene la URL del widget de pago.
 * @param {object} params - Parámetros de la orden (invoice_amount, currency, etc.).
 * @returns {Promise<object>} - La respuesta de la API, incluyendo el widget_url.
 */
export const startBuyOrder = async (params = {}) => {
     const jwt = localStorage.getItem('jwt');
     if (!jwt) throw new Error('Authentication token not found.');

     // 1. La URL ya no lleva los parámetros
     const url = `${API_BASE_URL}/esg/start-buy-order`;

     try {
          const response = await fetch(url, {
               method: 'POST',
               headers: {
                    'Content-Type': 'application/json',
               },
               // 2. Los parámetros ahora van en el body de la petición
               body: JSON.stringify(params),
               cache: 'no-store'
          });

          if (!response.ok) {
               const errorData = await response.json();
               throw new Error(errorData.message || `API Error: ${response.status}`);
          }

          return await response.json();

     } catch (error) {
          console.error("Error starting buy order:", error);
          throw error;
     }
};

/**
 * Verifica el estado de una orden de compra existente.
 * @param {object} params - Parámetros para identificar la orden (payment_id, etc.).
 * @returns {Promise<object>} - La respuesta de la API con el estado de la orden.
 */
export const checkBuyOrder = async (params = {}) => {
     const jwt = localStorage.getItem('jwt');
     if (!jwt) throw new Error('Authentication token not found.');

     const queryString = new URLSearchParams(params).toString();
     const url = `${API_BASE_URL}/esg/check-buy-order?${queryString}`;

     try {
          const response = await fetch(url, {
               method: 'GET',
               headers: {
                    'Authorization': `Bearer ${jwt}`
               }
          });

          if (!response.ok) {
               const errorData = await response.json();
               throw new Error(errorData.message || `API Error: ${response.status}`);
          }

          return await response.json();

     } catch (error) {
          console.error("Error checking buy order:", error);
          throw error;
     }
};
